import { Divider, Grid } from '@mui/material';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import BusinessDefinationFilter from '../../../../components/filters/components/BusinessDefinationFilter';
import CardWrapper from '../../childRoutes/CardWrapper';
import { CampaignHeader, DuretionInput, SectionHeaders, TOGGLE_VARIANT } from '../../components';

import { EmailCampaignSettingCardProps } from './CandidateRulesCard';

const AdditionalRulesCard = ({ onReset, onSave }: EmailCampaignSettingCardProps) => (
  <CardWrapper>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
      Additional Rules
    </WsTypography>
    <Grid p={2} display="flex" direction="column" rowGap={2}>
      <CampaignHeader name="excludeCandidateEmailCheck" skip={true}>
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Exclude candidates who received any job email
        </WsTypography>
      </CampaignHeader>
      <DuretionInput
        tagLine="Ignore candidates contacted in the past"
        durationName="excludeCandidateEmail"
        timeSpanName="excludeCandidateEmailDuration"
      />
      <Divider />
      <CampaignHeader name="deliverabilityCheck" skip variant={TOGGLE_VARIANT.ENABLE}>
        <SectionHeaders
          title={'Deliverability Check'}
          subTitle={'Exclude candidates with high bounce rates or unsubscribed emails.'}
        />
      </CampaignHeader>
      <Divider />
      <CampaignHeader
        name="excludeCandidatehiringCheck"
        skip={true}
        variant={TOGGLE_VARIANT.ENABLE}
      >
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Exclude candidates in the hiring pipeline for similar roles.
        </WsTypography>
      </CampaignHeader>
      <Divider />
      <CampaignHeader name="submissionCheck" skip={true}>
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Exclude candidates submitted recently
        </WsTypography>
      </CampaignHeader>
      <DuretionInput
        tagLine="Ignore candidates submitted in past"
        durationName="lastSubmission"
        timeSpanName="submissionDuration"
      />

      <Grid xs={8} display="flex" direction="column" rowGap={1}>
        <WsTypography>Under Business Definitions</WsTypography>
        <BusinessDefinationFilter name="businessDefinitions" />
      </Grid>

      <Divider />
      <CampaignHeader name="validEmailCheck" skip variant={TOGGLE_VARIANT.ENABLE}>
        <SectionHeaders
          title={'Clean email list before sending'}
          subTitle={'Remove invalid or duplicate emails before sending.'}
        />
      </CampaignHeader>

      <Grid display="flex" justifyContent="flex-end" columnGap={2}>
        <WsButton variant="outlined" onClick={onReset}>
          Discard
        </WsButton>
        <WsButton onClick={onSave}>Save</WsButton>
      </Grid>
    </Grid>
  </CardWrapper>
);

export default AdditionalRulesCard;
